import React, { useContext, useState } from "react";
import styled from "styled-components";
import radioCheck from "../../../assets/images/Radio.png";
import plus from "../../../assets/images/plus.png";
import radioUnCheck from "../../../assets/images/RadioUnCheck.png";
import Vector from "../../../assets/images/chevron-up0.svg";
import klarna from "../../../assets/images/Klarna.png";
import applePay from "../../../assets/images/ApplePay.png";
import googlePay from "../../../assets/images/GooglePay.png";
import { paymentMethods } from "../../../utils/helperFunctions";
import * as Library from "../../../utils/Library";
import LayoutContext from "../../../contexts/LayoutContext";
import UserContext from "../../../contexts/UserContext";
import { useShowSocialPayment } from "../../../utils/payments";
import Spinner from "../../../assets/images/loader.svg";

const StyledPage = styled.div`
    .location-indicators,
    .location-indicators * {
        box-sizing: border-box;
    }
    .location-indicators {
        background: var(--buttons-button-quaternary, rgba(166, 166, 166, 0.1));
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        width: 372px;
    }
    .selected {
        opacity: 1;
    }
    .not-selected {
        opacity: 0.2;
    }
    .frame-29614 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313472 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .choose-other-payment-method {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        position: relative;
        width: 240px;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
        overflow: visible;
        rotate: 0deg;
        cursor: pointer;
    }
    .frame-1000011174 {
        display: flex;
        flex-direction: column;
        gap: 7px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011194 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .payment-method-button-40-px {
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 0px 0px 1px 0px;
        padding: 10px 0px 10px 0px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 40px;
        position: relative;
    }
    .radio {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
        cursor: pointer;
    }
    .ellipse-1 {
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .frame {
        background: #ffb3c7;
        border-radius: 3px;
        padding: 7px 3px 7px 3px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 37px;
        height: 21px;
        position: relative;
    }
    .group {
        flex-shrink: 0;
        width: 30.79px;
        height: 6.94px;
        position: relative;
        overflow: visible;
    }
    .other-pay-method-variant-9 {
        flex-shrink: 0;
        width: 43.84px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .group-1000011159 {
        flex-shrink: 0;
        width: 45.29px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .group-1000011160 {
        flex-shrink: 0;
        width: 20.84px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .group2 {
        flex-shrink: 0;
        height: 20px;
        position: relative;
        overflow: visible;
    }
    .layer-1 {
        flex-shrink: 0;
        width: 59.13px;
        height: 18px;
        position: relative;
        overflow: hidden;
    }
    .vector {
        width: 61.57%;
        height: 54.69%;
        position: absolute;
        right: 0%;
        left: 38.43%;
        bottom: 26.54%;
        top: 18.77%;
        overflow: visible;
    }
    .group3 {
        width: 21.78%;
        height: 88.29%;
        position: absolute;
        right: 69.56%;
        left: 8.66%;
        bottom: 0%;
        top: 11.7%;
        overflow: visible;
    }
    .vector2 {
        width: 21.78%;
        height: 88.29%;
        position: absolute;
        right: 78.22%;
        left: 0%;
        bottom: 11.7%;
        top: 0%;
        overflow: visible;
    }
    .vector3 {
        width: 19.87%;
        height: 71.54%;
        position: absolute;
        right: 78.22%;
        left: 1.92%;
        bottom: 28.46%;
        top: 0%;
        overflow: visible;
    }
    .group-1000011162 {
        flex-shrink: 0;
        width: 54.32px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .payment-method-button-40-px2 {
        padding: 10px 0px 10px 0px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 40px;
        position: relative;
    }
    .group-1000011158 {
        flex-shrink: 0;
        width: 67.89px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .btn-lg-solids {
        width: 100%;
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        opacity: 1;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        cursor: pointer;
        margin-top: 20px;
    }
    .btn-solid {
        width: 100%;
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        opacity: 0.2;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .plus {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
const PaymentMethodsComponent = ({ setShowPaymentMethods, handleStates = () => {} }) => {
    const [selectedPaymentType, setSelectedPaymentType] = useState("");
    const { BOTagAccountID } = useContext(UserContext);
    const [loader, setLoader] = useState(false);
    const { checkPaymentMethods } = useShowSocialPayment();

    const handleUpdatePaymentMethod = async () => {
        try {
            const res = await Library.makePostRequest(
                "updateUserDefaultPaymentMethod",
                {
                    paymentMethodType: selectedPaymentType || "",
                    accountId: BOTagAccountID || ""
                },
                false,
                setLoader //loader
            );
            handleStates({ res });
        } catch (error) {}
    };

    return (
        <StyledPage style={{ width: "100%" }}>
            <div className="location-indicators">
                <div className="frame-29614">
                    <div className="frame-313472">
                        <div className="choose-other-payment-method">Choose other payment method</div>
                    </div>
                    <img className="chevron-right" src={Vector} alt="" onClick={() => setShowPaymentMethods(false)} />
                </div>
                <div className="frame-1000011174">
                    <div className="frame-1000011194">
                        <PaymentMethod
                            selectMethod={selectedPaymentType}
                            img={klarna}
                            onSelect={() => setSelectedPaymentType(paymentMethods.KLARNA_PAY)}
                            isSelected={selectedPaymentType === paymentMethods.KLARNA_PAY}
                        />
                        {checkPaymentMethods.applePay && (
                            <PaymentMethod
                                selectedPaymentType={selectedPaymentType}
                                img={applePay}
                                onSelect={() => setSelectedPaymentType(paymentMethods.APPLE_PAY)}
                                isSelected={selectedPaymentType === paymentMethods.APPLE_PAY}
                            />
                        )}
                        {checkPaymentMethods.googlePay && (
                            <PaymentMethod
                                selectedPaymentType={selectedPaymentType}
                                img={googlePay}
                                onSelect={() => setSelectedPaymentType(paymentMethods.GOOGLE_PAY)}
                                isSelected={selectedPaymentType === paymentMethods.GOOGLE_PAY}
                            />
                        )}
                        <div
                            className="btn-lg-solids"
                            onClick={handleUpdatePaymentMethod}
                            style={{ backgroundColor: loader && "transparent" }}>
                            <div className="frame-29590">
                                <div className="button">
                                    {loader ? <img src={Spinner} alt="" height={"20px"} /> : <img className="plus" src={plus} alt="" />}{" "}
                                    &nbsp;
                                    {loader ? `Connecting to ${selectedPaymentType}...` : "Add new payment method"}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledPage>
    );
};

export default PaymentMethodsComponent;

const RadioButton = ({ isSelected, onSelect }) => {
    return (
        <div className="radio">
            {isSelected ? (
                <img src={radioCheck} alt="" height={"20px"} onClick={onSelect} />
            ) : (
                <img src={radioUnCheck} alt="" height={"20px"} onClick={onSelect} />
            )}
        </div>
    );
};

const PaymentMethod = ({ img, isSelected, onSelect }) => {
    return (
        <div className="payment-method-button-40-px">
            <div className="radio">
                <RadioButton isSelected={isSelected} onSelect={onSelect} />
            </div>
            <img className="group2" src={img} alt="" />
        </div>
    );
};
